import { INoteCellLinkOffsets } from '../../interfaces/noteCellLink'

/** Note text split around the span that produced a link, for highlighted display. */
export interface HighlightSegments {
  before: string
  match: string
  after: string
}

/**
 * Splits note text around the wording Arc keyed on, so a reviewer can see the evidence
 * rather than take the suggestion on faith.
 *
 * Offsets are recorded against the note text at match time, but the text shown can drift
 * from it — an edited note, an established fact rendering a label instead, a truncated
 * value. Any span that does not sit cleanly inside the text is discarded and the text is
 * returned whole: showing it unhighlighted is a small loss, slicing at a stale offset would
 * mangle it.
 */
export const splitOnMatch = (
  text: string | null | undefined,
  offsets: INoteCellLinkOffsets[] | null | undefined,
): HighlightSegments => {
  const source = text ?? ''
  const span = offsets?.[0]

  const isUsable =
    !!span &&
    Number.isInteger(span.start) &&
    Number.isInteger(span.end) &&
    span.start >= 0 &&
    span.end <= source.length &&
    span.start < span.end

  if (!isUsable) return { before: source, match: '', after: '' }

  return {
    before: source.slice(0, span.start),
    match: source.slice(span.start, span.end),
    after: source.slice(span.end),
  }
}
